import React from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 350px;
  max-width: 92%;
  padding: 35px 24px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.18);
  position: relative;
`;

const Close = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #888;
  font-size: 16px;
`;

const Message = styled.p`
  text-align: center;
  font-size: 15px;
  color: #333;
  margin: 16px 4px 22px 4px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;
`;

const Btn = styled.button`
  padding: 8px 40px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
`;

const BtnYes = styled(Btn)`
  background: #6ED08A;
  color: #fff;
  &:hover { background: #409040; }
`;

const BtnNo = styled(Btn)`
  background: #F46464;
  color: #fff;
  &:hover { background: #e04a4a; }
`;

export default function ModalExclusao({ open, onClose, onConfirm, count = 1 }) {
  if (!open) return null;

  const msg = count > 1 ? `Deseja confirmar a exclusão de ${count} ${count > 1 ? 'designações' : 'designação'}?` : 'Deseja confirmar a exclusão da designação?';

  return (
    <Overlay>
      <ModalBox role="dialog" aria-modal="true">
        <Close aria-label="Fechar" onClick={onClose}><FaTimes /></Close>
        <Message>{msg}</Message>
        <Actions>
          <BtnYes onClick={onConfirm}>SIM</BtnYes>
          <BtnNo onClick={onClose}>NÃO</BtnNo>
        </Actions>
      </ModalBox>
    </Overlay>
  );
}
